import type { FluxErrorEntityErrorCodes } from '../../types.js';

export const AutomationV2ExecutionActionAddCardLabelCodes = {
  AutomationV2ExecutionActionAddCardLabelFailedToAddLabel: {
    code: 'automation-v2-execution-action/add-card-label-failed-to-add-label',
    explanation: `Falha ao adicionar a etiqueta ao card.

**Causas comuns:**
- O usuário da automação não tem permissão para atualizar o card
- A etiqueta não existe ou foi excluída
- O card está arquivado ou bloqueado

**Como resolver:**
Verifique se a etiqueta existe no fluxo e se o usuário da automação tem permissão para editar o card.`,
    localizations: {},
    message: 'A automação não conseguiu adicionar a etiqueta ao card.',
    supportingDocs: [
      {
        name: 'Ação de Adicionar Etiqueta ao Card',
        path: '/wiki/docs/automations/actions/add-card-label',
      },
    ],
  },
  AutomationV2ExecutionActionAddCardLabelLabelNotFound: {
    code: 'automation-v2-execution-action/add-card-label-label-not-found',
    explanation: `A etiqueta especificada não foi encontrada no fluxo do card.

**Causas comuns:**
- O nome da etiqueta foi digitado incorretamente
- A etiqueta foi excluída do fluxo
- A etiqueta pertence a outro fluxo

**Como resolver:**
Verifique se o nome ou ID da etiqueta está correto e se ela existe no fluxo do card.`,
    localizations: {},
    message: 'A etiqueta especificada não foi encontrada no fluxo do card.',
    supportingDocs: [
      {
        name: 'Ação de Adicionar Etiqueta ao Card',
        path: '/wiki/docs/automations/actions/add-card-label',
      },
    ],
  },
  AutomationV2ExecutionActionAddCardLabelMissingCardId: {
    code: 'automation-v2-execution-action/add-card-label-missing-card-id',
    explanation: `ID do card é obrigatório no contexto da ação. O id do card é automaticamente passado pelo gatilho ou por ações anteriores.

**Causas comuns:**
- Variável cardId não resolvida
- Caso o valor do cardId seja mapeado manualmente, pode ter sido digitado incorretamente.
- Caso o valor do cardId não tenha sido mapeado, o \`context.card.id\` não está disponível.

**Como resolver:**
Corrija o mapeamento do ID do card.`,
    localizations: {},
    message:
      'Não foi possível adicionar a etiqueta ao card porque o ID do card está faltando. Verifique se o card existe no contexto da automação ou se foi digitado corretamente.',
    supportingDocs: [
      {
        name: 'Ação de Adicionar Etiqueta ao Card',
        path: '/wiki/docs/automations/actions/add-card-label',
      },
      {
        name: 'Informações Dinâmicas',
        path: '/wiki/docs/automations/informacoes-dinamicas',
      },
    ],
  },
  AutomationV2ExecutionActionAddCardLabelMissingLabelIdOrName: {
    code: 'automation-v2-execution-action/add-card-label-missing-label-id-or-name',
    explanation: `O ID ou nome da etiqueta não foi fornecido.

**Causas comuns:**
- O campo de etiqueta foi deixado em branco na configuração da ação
- A variável dinâmica de etiqueta retornou vazio

**Como resolver:**
Forneça o ID (UUID) ou o nome da etiqueta a ser adicionada.`,
    localizations: {},
    message: 'O ID ou nome da etiqueta é obrigatório para adicionar a etiqueta ao card.',
    supportingDocs: [
      {
        name: 'Ação de Adicionar Etiqueta ao Card',
        path: '/wiki/docs/automations/actions/add-card-label',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation-v2-execution-action'>;
